import React from 'react';

export function OutlinedMusicNote({
  fillColor = '#7F8287',
  className = '',
}: {
  fillColor?: string;
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.5"
        y="0.5"
        width="21"
        height="21"
        rx="1.5"
        fill={fillColor}
        stroke={fillColor}
      />
      <g clipPath="url(#clip0)">
        <path
          d="M13.2255 14.318C12.481 14.318 11.8751 13.8125 11.8751 13.1918C11.8751 12.571 12.481 12.0655 13.2255 12.0655C13.9701 12.0655 14.576 12.571 14.576 13.1918C14.576 13.8125 13.9701 14.318 13.2255 14.318ZM6.02316 15.9506C5.27861 15.9506 4.67271 15.4452 4.67271 14.8244C4.67271 14.2031 5.27861 13.6981 6.02316 13.6981C6.7677 13.6981 7.3736 14.2031 7.3736 14.8244C7.3736 15.4452 6.7677 15.9506 6.02316 15.9506ZM15.9264 5.37368C15.9264 5.26961 15.9026 5.16825 15.858 5.07725C15.8134 4.98624 15.7486 4.90515 15.6667 4.84073C15.5848 4.77676 15.4907 4.73351 15.3917 4.71279C15.2922 4.69161 15.1882 4.69297 15.0874 4.71819L11.4862 5.61921L7.88497 6.52022C7.73507 6.55761 7.60723 6.6441 7.51675 6.75988C7.42627 6.87566 7.3736 7.02073 7.3736 7.1757V10.3491V12.6804C6.97612 12.4691 6.51562 12.3466 6.02316 12.3466C4.53182 12.3466 3.32227 13.4557 3.32227 14.8244C3.32227 16.1926 4.53182 17.3022 6.02316 17.3022C7.5145 17.3022 8.72405 16.1926 8.72405 14.8244V7.70324L11.65 6.97117L14.576 6.2391V8.97998V11.0482C14.1785 10.837 13.718 10.714 13.2255 10.714C11.7342 10.714 10.5246 11.8231 10.5246 13.1918C10.5246 14.5604 11.7342 15.6695 13.2255 15.6695C14.7169 15.6695 15.9264 14.5604 15.9264 13.1918V5.37368Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="13.75"
            height="13.75"
            fill="white"
            transform="translate(2.75 4.125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
